import { ButtonHTMLAttributes, FunctionComponent } from 'react'
import clx from '../util/clx'

type Props = ButtonHTMLAttributes<HTMLButtonElement>

const Button: FunctionComponent<Props> = props => {
	const { children, className, name, ...rest } = props

	const cl = clx('button', { [`button--${name}`]: !!name }, className)

	return (
		<button className={cl} {...rest}>
			{children}
		</button>
	)
}

export default Button
